import {
  GET_LIST_DANHSACHCUAHANG,
  GET_LIST_DANHSACHCUAHANG_SUCCESS,
  GET_LIST_DANHSACHCUAHANG_FAILURE,
  UPDATE_SEARCHDATA_CUAHANG,
  UPDATE_THONGTIN_CUAHANG,
} from "./actionTypes";

export const getDanhSachCuaHang = (dataSearch) => ({
  type: GET_LIST_DANHSACHCUAHANG,
  dataSearch,
});

export const getDanhSachCuaHangSuccess = (data) => ({
  type: GET_LIST_DANHSACHCUAHANG_SUCCESS,
  payload: data,
});

export const getDanhSachCuaHangFailure = () => ({
  type: GET_LIST_DANHSACHCUAHANG_FAILURE,
});

export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHDATA_CUAHANG,
  payload: data,
});

export const updateThongTinCuaHang = (data) => ({
  type: UPDATE_THONGTIN_CUAHANG,
  payload: data,
});
